$(function () {
  $(".tokinoha-slideshow ul").slick({
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 1000,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: "15%",
    dots: true,
    responsive: [
      {
        breakpoint: 999, // 399px以下のサイズに適用
        settings: {
          slidesToShow: 1,
          centerPadding: "0",
        },
      },
    ],
  });
});